class Extranet.Helper.AlertView

  @initialize: (selector)->
    @alertView ?= new Extranet.Views.AlertMessage {selector}

  @getAlertView: () ->
    @alertView
